// extracted by mini-css-extract-plugin
export default {"table-item":"objectWidget_table-item__8SQmr","table-item--nested":"objectWidget_table-item--nested__lT0vc","column-item":"objectWidget_column-item__eDBHn"};